export default "__VITE_ASSET__Ce2jeViu__"